import React from 'react';
import PropTypes from 'prop-types';
import { manageEventListener } from '../../../common/utils';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { allowedMessageProps } from './_allowedPropTypes';
import MessageText from './_MessageText';
import { Button } from '../../elements/ActionElement';

class MessageListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDismissed: false,
      previouslyFocused: null
    };

    this.dismissMessage = this.dismissMessage.bind(this);
    this.manageEventListeners = this.manageEventListeners.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.refMessageListItem = React.createRef();
    this.refButtonCloser = React.createRef();
  }

  componentDidMount() {
    const {
      dismissMessage,
      manageEventListeners,
      refButtonCloser: {
        current: closerButtonElement
      }
    } = this;

    if (closerButtonElement) {
      this.setState({ previouslyFocused: document.activeElement }, () => {
        setTimeout(() => closerButtonElement.focus(), 200);
      });
    }

    setTimeout(() => dismissMessage(), 4000);
    manageEventListeners('add');
  }

  componentDidUpdate() {
    const {
      props: {
        bulkDismissed
      },
      state: {
        isDismissed
      },
      dismissMessage
    } = this;

    if (bulkDismissed && !isDismissed) {
      dismissMessage();
    }
  }

  componentWillUnmount() {
    const {
      state: {
        previouslyFocused
      },
      manageEventListeners
    } = this;

    manageEventListeners('remove');

    if (previouslyFocused) {
      previouslyFocused.focus();
    }
  }

  dismissMessage() {
    const {
      state: {
        previouslyFocused
      }
    } = this;

    this.setState({ isDismissed: true }, () => {
      previouslyFocused.focus();
    });
  }

  handleTransitionEnd({ currentTarget, propertyName }) {
    const {
      props: {
        removeFromMessageList
      },
      state: {
        isDismissed
      },
      refMessageListItem: {
        current: messageItemElement
      }
    } = this;

    if (isDismissed && currentTarget === messageItemElement && propertyName === 'visibility') {
      removeFromMessageList();
    }
  }

  manageEventListeners(action) {
    const {
      handleTransitionEnd,
      refMessageListItem: {
        current: messageItemElement
      }
    } = this;

    manageEventListener(messageItemElement, 'transitionend', action, handleTransitionEnd);
  }

  render() {
    const {
      props: {
        mood,
        message,
        translate
      },
      state: {
        isDismissed
      },
      refMessageListItem,
      refButtonCloser,
      dismissMessage
    } = this;

    const classNames = ['system-message-item', `mood-${mood}`];

    if (isDismissed) {
      classNames.push('closed');
    }

    return (
      <li
        className={classNames.join(' ')}
        title={translate('list-item-title')}
        ref={refMessageListItem}
      >
        <MessageText
          text={message}
          mood={mood}
        />

        <Button
          onClick={dismissMessage}
          appearance='buttonWrap'
          className='closer-system-message-item'
          title={translate('list-item-button-dismiss-title')}
          iconName='times'
          disabled={false}
          ref={refButtonCloser}
        />
      </li>
    );
  }
}

MessageListItem.propTypes = {
  ...allowedMessageProps,
  removeFromMessageList: PropTypes.func.isRequired,
  bulkDismissed: PropTypes.bool
};

export default withLocalization(MessageListItem, 'lists/systemMessages');